import React from 'react';
import { useFieldHelper, EmailField, FieldProps } from 'framework/ui/field';

const ContactEmailField = (props: FieldProps) => {
  const { getValue, getLabel } = useFieldHelper(props);

  const value = getValue();
  const firstEmail = value && value.length ? value[0] : null;

  return <EmailField label={getLabel()} value={firstEmail} />;
};

export default ContactEmailField;
